import { ClubSlug } from '@/fairplayer/domain/club/ClubSlug';
import { Wallet } from '@/fairplayer/domain/Wallet';
import { InjectionKey } from 'vue';

export const walletRepositoryKey: InjectionKey<WalletRepository> = Symbol();

export interface WalletRepository {
  getForClub(clubSlug: ClubSlug): Promise<Wallet>;
}
